import { useTranslation } from 'react-i18next';

import { ReactComponent as TrashIcon } from '../../../../../../../../assets/icons/trash-new.svg';
import CustomButton from '../../../../../../../../shared/components/Buttons/CustomButton/CustomButton';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../shared/translations/quotes';

export interface ICensusInfo {
  fileName: string;
  rowCount: number;
}

interface ICensusLoadedRowProps {
  censusInfo: ICensusInfo;
  onRemove: () => void;
}

export default function CensusLoadedRow({ censusInfo, onRemove }: Readonly<ICensusLoadedRowProps>) {
  const { t } = useTranslation();

  return (
    <div className="quote-product-row__census-loaded-row">
      <span className="quote-product-row__census-loaded-tag">
        <span aria-hidden="true">✓ </span>
        {t(TRANSLATIONS_QUOTES.create.row.censusLoaded)}
      </span>
      <span className="quote-product-row__census-loaded-meta">
        {t(TRANSLATIONS_QUOTES.create.row.censusLoadedMeta, {
          count: censusInfo.rowCount,
          fileName: censusInfo.fileName
        })}
      </span>
      <CustomButton
        variant="default"
        size="xs"
        className="quote-product-row__census-remove-btn"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
      >
        <TrashIcon className="quote-product-row__census-remove-icon" aria-hidden="true" />
        {t(TRANSLATIONS_QUOTES.create.row.removeCensus)}
      </CustomButton>
    </div>
  );
}
